import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { countries } from "constants/apiUrls";

// Backend response format for country-extensions
export interface CountryExtensionAPIResponse {
  countryName: string;
  countryShortCode: string;
  image: string;
  extension: string;
}

// Frontend normalized format
export interface CountryExtension {
  name: string;
  dialCode: string;
  code: string;
  flag?: string;
}

const countryExtensionApi = createApi({
  reducerPath: "countryExtension",
  baseQuery: fetchBaseQuery({ baseUrl: "" }),
  endpoints: (builder) => ({
    countryExtensions: builder.query<CountryExtension[], void>({
      query: () => {
        const mandatoryHeaders = {
          "bludot-app-name": "business-rewards",
          "Content-Type": "application/json",
        };
        return {
          url: countries,
          headers: mandatoryHeaders,
        };
      },
      transformResponse: (response: any) => {
        // Extract countries from paginated response
        const countriesArray =
          response?.result || (Array.isArray(response) ? response : []);

        if (countriesArray.length > 0) {
          // Map to our format with proper phone code formatting
          const mapped = countriesArray.map((country: any) => {
            // Ensure phone code has "+" prefix
            const phoneCode = country.phoneCode || country.extension || "1";
            const dialCode = phoneCode.startsWith("+")
              ? phoneCode
              : `+${phoneCode}`;

            return {
              name: country.name,
              dialCode: dialCode,
              code: country.isoCode,
              flag: country.flag,
            };
          });

          return mapped;
        }

        return [];
      },
    }),
  }),
});

export const { useCountryExtensionsQuery, useLazyCountryExtensionsQuery } =
  countryExtensionApi;
export default countryExtensionApi;
